import PlatformError from "../PlatformError";

export default new PlatformError(
  "ERROR",
  "Connection speed was determined to be too low.",
  "Screenout",
  "Connection speed was determined to be too low.",
  "app.error.connectionspeed"
);
